import { CACHE_ENABLED } from "src/config/cache.config";

import { QueryClient } from "@tanstack/react-query";

/**
 * Singleton QueryClient instance used across the application.
 * Extracted into its own module to avoid circular dependencies
 * between index.tsx and the services layer.
 *
 * When REACT_APP_CACHE_ENABLED is "false", caching is globally
 * disabled by setting staleTime and gcTime to 0.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...(!CACHE_ENABLED && { staleTime: 0, gcTime: 0 }),
    },
  },
});
